import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { chainId, currentGasChange } from '@/store'
import { useProviderInstance } from '@/context/ProviderContext'

let gasManagerInstance = null
let intervalId = null

export function useGasManager() {
    const dispatch = useDispatch()
    const _chainId = useSelector(chainId)
    const provider = useProviderInstance()
    const providerRef = useRef(provider)

    useEffect(() => {
        providerRef.current = provider
    }, [provider])

    // 单例模式：确保整个应用只有一个实例
    if (!gasManagerInstance) {
        gasManagerInstance = {
            start: () => { },
            stop: () => { },
        }
    }

    const fetchGasPrice = async () => {
        const p = providerRef.current
        if (!p) return
        try {
            const gasPrice = await p.getGasPrice() // bigint
            const adjustedGas =
                _chainId === 97 || _chainId === 56
                    ? gasPrice
                    : (gasPrice * 150n) / 100n
            dispatch(currentGasChange(adjustedGas))
        } catch (err) {
            console.error("🚨 获取 GasPrice 失败:", err)
        }
    }

    useEffect(() => {
        fetchGasPrice()
    }, [provider])

    return { fetchGasPrice }
}